import React from 'react';
import PropTypes from 'prop-types';

import { CircularProgress } from '@mui/material';
import { DeviceAccordion } from 'components/admin/businesses/devices/DeviceAccordion';
import { EmptyList } from 'components/admin/businesses/devices/EmptyList';

export function Batches({ batchList, isBatchesLoading, businessOwner, deviceError }) {
  if (isBatchesLoading) {
    return <CircularProgress />;
  }

  if (batchList?.length === 0 && !isBatchesLoading) {
    return <EmptyList error={deviceError} />;
  }

  return (
    <>
      {batchList.map((batch) => (
        <DeviceAccordion key={batch.id} batch={batch} businessOwner={businessOwner} />
      ))}
    </>
  );
}

Batches.propTypes = {
  batchList: PropTypes.arrayOf(
    PropTypes.shape({
      createdAt: PropTypes.string,
      deviceCount: PropTypes.number,
      id: PropTypes.number,
      isAssigned: PropTypes.bool,
    }),
  ),
  isBatchesLoading: PropTypes.bool,
  businessOwner: PropTypes.shape({
    batchCount: PropTypes.number,
    businessid: PropTypes.number,
    deviceCount: PropTypes.number,
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    name: PropTypes.string,
    userId: PropTypes.number,
  }),
  deviceError: PropTypes.string,
};
